import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M25 12a9 9 0 1 0-13.617 7.728 15 15 0 0 0-8.375 6.77A1 1 0 0 0 4.739 27.5 13 13 0 0 1 16 21l.372.005c4.501.129 8.627 2.58 10.889 6.494a1 1 0 0 0 1.731-1 15 15 0 0 0-8.376-6.771A9 9 0 0 0 25 12m-8.971 7h-.058l-.212-.004a7 7 0 1 1 .27.004"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconUser = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconUser);
export default Memo;
